import config from '../config';
import { requestJson } from './http';

const toQuery = (params = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  ).toString();
  return query ? `?${query}` : '';
};

/**
 * Best time per player on one track: world top 10, plus the country top 10
 * when countryId is given.
 * `excludeLost` skips results saved with result "lost" (e.g. Maze timeouts);
 * results of games that store other data in `result` are unaffected.
 * @param {{ gameModeId: number|string, trackName: string, countryId?: number|string, excludeLost?: boolean }} params
 * @returns {Promise<{ trackName: string, worldRankings: Object[], countryRankings: Object[] }>}
 */
export const getTrackRanking = (params) =>
  requestJson(
    `${config.apiUrl}/game-result/track-ranking${toQuery(params)}`,
    {},
    'Failed to load the track leaderboard'
  );

/**
 * Top 5 players for a game mode. Score games return `maxScore`, time games
 * return `bestTime`.
 * @param {{ gameModeId: number|string, resultType: 'score'|'time', trackName?: string }} params
 * @returns {Promise<Object[]>}
 */
export const getTopRanking = (params) =>
  requestJson(`${config.apiUrl}/game-result/top-ranking${toQuery(params)}`, {}, 'Failed to load the leaderboard');

/**
 * Best time per Coop team on one track (top 10); with teamId, also that
 * team's own standing in `team`.
 * @param {{ gameModeId: number|string, trackName: string, teamId?: number|string, minPlayers?: number }} params
 * @returns {Promise<{ trackName: string, teams: Object[], team: { rank: number, bestTime: number } | null }>}
 */
export const getTeamTrackRanking = (params) =>
  requestJson(
    `${config.apiUrl}/game-result/team-track-ranking${toQuery(params)}`,
    {},
    'Failed to load the team leaderboard'
  );
